<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('HOLIDAY.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <holiday-form
          v-model="form"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-btn depressed color="error" @click="remove">
        {{ $t('BUTTON.DELETE') }}
      </v-btn>
      <confirm-dialog ref="confirm"></confirm-dialog>
      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="update">
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import HolidayForm from './forms/HolidayForm.vue';
import { HolidaysService } from '@/services/holidays.service';
import { isEqual } from 'lodash';
import moment from 'moment';

export default {
  name: 'EditHoliday',

  components: {
    HolidayForm,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  mixins: [errors],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      valid: true,
      form: {}
    };
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  methods: {
    valueWatchHandler(formProps) {
      if (!formProps.id) {
        return;
      }
      this.getHoliday(formProps.id);
    },

    getHoliday(id) {
      HolidaysService.getById(id)
        .then(({ data }) => {
          this.form = { ...data };
          this.form.regions = this.form.regions.map(({ id }) => id);
          const momentDate = moment(`${this.form.day}.${this.form.month}.${this.form.year}`, "D.M.YYYY");
          this.form.day = momentDate.format('DD');
          this.form.month = momentDate.format('MM');
          this.form.year = this.form.year ? this.form.year.toString() : '';
        })
        .catch(this.handleErrors);
    },

    cancel() {
      this.$emit('cancel');
    },

    update() {
      if (!this.$refs.form.validate()) {
        return;
      }

      HolidaysService.update(this.form.id, this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('updated', data.data);
        })
        .catch(this.handleErrors);
    },

    remove() {
      this.$refs.confirm
        .open(this.$t('HOLIDAY.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            HolidaysService.remove(this.form.id)
              .then(({ data }) => {
                this.$emit('updated', data.data);
                this.$store.commit('snackbar/setSnack', {
                  status: 'success',
                  text: this.$t('MESSAGE.SUCCESS')
                });
              })
              .catch(this.handleErrors);
          }
        });
    }
  }
};
</script>
